import { gql } from '@apollo/client'

export const GET_VEHICLES_V2 = gql`
  query GetVehiclesV2($input: TVehiclesInput, $pagination: TPagination) {
    tvehicles(input: $input, pagination: $pagination) {
      total
      items {
        id
        externalID
        name
        status
        isAssigned
        createdAt
        template {
          id
          name
          capacity
          type
        }
        partner {
          id
          name
          isActive
        }
        drivers {
          id
          name
        }
        routeServices {
          id
          code
        }
        licensePlates {
          type
          number
          stateCode
        }
        features {
          make
          model
        }
      }
    }
  }
`

export const GET_VEHICLE_V2 = gql`
  query GetVehicleV2($input: TVehicleInput!) {
    tvehicle(input: $input) {
      id
      name
      vin
      externalID
      cityName
      stateCode
      odometerReading
      companies {
        id
        name
      }
      partner {
        id
        name
      }
      template {
        id
        name
        capacity
        type
      }
      cards {
        tagCards
        fuelCards
      }
      features {
        brandCoverage
        make
        model
        year
        amenities
      }
      licensePlates {
        type
        number
        stateCode
      }
      drivers {
        id
        name
      }
      registrationDetails {
        stateCode
        isPermanent
        expirationDate
        type
        category
        document {
          path
          name
        }
      }
      insurancePolicy {
        expirationDate
        document {
          path
          name
        }
      }
      documents {
        document {
          path
          name
        }
        category
      }
    }
  }
`

export const GET_VEHICLES_SUGGESTIONS = gql`
  query GetVehiclesSuggestions($input: VehicleSuggestionsInput!, $pagination: PaginationV2) {
    vehicleSuggestions(input: $input, pagination: $pagination) {
      total
      items {
        id
        name
        capacity
        externalID
      }
    }
  }
`
